import React, { useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DropDown from '../../cm/common/DropDown';
import { Button, Col, Row, Slider, Space } from 'antd';
import useAlertLevelConfigs from '../../common/hooks/useAlertLevelConfig';

const railStyle = { background: '#91d5ff' };
const trackStyle = { background: '#f5f5f5' };

const DetailsFilters = ({
  className,
  filters,
  onChange,
  filterData,
  resetFilter,
  alertLevels
}) => {
  const { formatAlertLevelOptions } = useAlertLevelConfigs(alertLevels);

  const hitLevelOptions = useMemo(
    () => formatAlertLevelOptions(),
    [alertLevels]
  );

  return (
    <Container className={className}>
      <StyledDropDown
        label="Hit Level"
        placeholder={`Please select`}
        options={hitLevelOptions}
        allowClear
        value={filters?.hitLevel}
        onChange={(value) => onChange('hitLevel', value)}
      />
      <StyledDropDown
        label="Watchlist Name"
        placeholder={`Please select`}
        options={filterData?.nameOfWatchlist.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.nameOfWatchlist}
        onChange={(value) => onChange('nameOfWatchlist', value)}
      />
      <StyledDropDown
        label="Watchlist Category"
        placeholder={`Please select`}
        options={filterData?.watchlistCategory.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistCategory}
        onChange={(value) => onChange('watchlistCategory', value)}
      />
      <StyledDropDown
        label="Watchlist Sub-Category"
        placeholder={`Please select`}
        options={filterData?.watchlistSubCategory.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistSubCategory}
        onChange={(value) => onChange('watchlistSubCategory', value)}
      />
      <StyledDropDown
        label="Watchlist Keyword"
        placeholder={`Please select`}
        options={filterData?.watchlistKeyword.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistKeyword}
        onChange={(value) => onChange('watchlistKeyword', value)}
      />
      <StyledDropDown
        label="Watchlist Source"
        placeholder={`Please select`}
        options={filterData?.watchlistSource.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistSource}
        onChange={(value) => onChange('watchlistSource', value)}
      />
      <div style={{ marginTop: '10px' }}>
        <p>Hit Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('hitScore', value)}
            value={filters?.hitScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>Name Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('nameScore', value)}
            value={filters?.nameScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>Alias Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('aliasScore', value)}
            value={filters?.aliasScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>Address Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('addressScore', value)}
            value={filters?.addressScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>DOB Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('dobScore', value)}
            value={filters?.dobScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>Country of Birth Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('cobScore', value)}
            value={filters?.cobScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>Nationality Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('nationalityScore', value)}
            value={filters?.nationalityScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>Gender Score</p>
        <Col span={18}>
          <Slider
            min={0}
            max={100}
            marks={{ 0: '0', 100: '100' }}
            defaultValue={0}
            step="1"
            onChange={(value) => onChange('genderScore', value)}
            value={filters?.genderScore}
            railStyle={railStyle}
            trackStyle={trackStyle}
          />
        </Col>
      </div>
      <Button
        type="primary"
        style={{
          marginTop: '20px',
          background: '#2B73E0',
          borderColor: '#2B73E0'
        }}
        onClick={resetFilter}>
        <Space>Reset</Space>
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  & > * {
    margin-right: 22px;
  }
`;
const StyledDropDown = styled(DropDown)`
  width: 300px;
`;

DetailsFilters.propTypes = {
  alertLevels: PropTypes.array,
  className: PropTypes.string,
  filters: PropTypes.object,
  filterData: PropTypes.object,
  onChange: PropTypes.func,
  resetFilter: PropTypes.func
};

export default DetailsFilters;
